import script from "./private.vue?vue&type=script&setup=true&lang=js"
export * from "./private.vue?vue&type=script&setup=true&lang=js"

import "./private.vue?vue&type=style&index=0&id=aeb1b3d2&scoped=true&lang=css"

import exportComponent from "C:\\D\\workspace\\idea\\tkt-web\\camee-sport-pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aeb1b3d2"]])

export default __exports__